"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Suit = void 0;
var Suit;
(function (Suit) {
    Suit[Suit["CLUB"] = 0] = "CLUB";
    Suit[Suit["DIAMOND"] = 1] = "DIAMOND";
    Suit[Suit["HEART"] = 2] = "HEART";
    Suit[Suit["SPADE"] = 3] = "SPADE";
})(Suit || (exports.Suit = Suit = {}));
//# sourceMappingURL=Suit.js.map